import styled from 'styled-components';
import React from 'react';
import { SelectField, IconButton, TextButton, } from '@oneaudi/unified-web-components';
import { SYS_BREAKPOINT_LG, SYS_BREAKPOINT_MD, SYS_COLOR_SURFACE_NEUTRAL_100_DARK, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_300, SYS_SPACE_FIXED_450, SYS_SPACE_RELATIVE_MD, } from '@oneaudi/unified-web-common';
export const MasOverlayContainer = styled.div `
  display: flex;
  flex-flow: column;
  }
`;
export const MasOverlayHeadlineWrapper = styled.div `
  width: 100%;
  padding-block-end: ${SYS_SPACE_FIXED_200};
  }
`;
export const ConsentRequestWrapper = styled.div `
  padding-block-end: ${SYS_SPACE_FIXED_200};
  }
`;
export const LocationInputWrapper = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: end;
  padding-block-end: ${SYS_SPACE_FIXED_450};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    flex-direction: row;
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    height: 57px;
    margin-top: unset;
  }
`;
export const SearchWrapper = styled.div `
  display: flex;
  width: 100%;
  justify-content: space-between;
`;
export const SearchStyle = styled.div `
  align-content: end;
  width: 100%;
`;
export const LocateMeButton = styled((props) => React.createElement(IconButton, Object.assign({}, props))) ``;
export const StyledSelect = styled((props) => React.createElement(SelectField, Object.assign({}, props))) `
  margin-top: ${SYS_SPACE_FIXED_300};
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    margin-top: unset;
    padding-inline-start: ${SYS_SPACE_FIXED_300};
  }
`;
export const StyledResultsButton = styled((props) => React.createElement(TextButton, Object.assign({}, props))) `
  width: auto;
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    width: fit-content;
  }
  display: flex;
  justify-content: center;
  :disabled {
    box-shadow: none;
  }
`;
export const CookieConsentWrapper = styled.div `
  width: 100%;
  display: flex;
  align-items: flex-start;
  padding: ${SYS_SPACE_RELATIVE_MD};
  margin-bottom: ${SYS_SPACE_FIXED_450};
  gap: 16px;
  color: ${SYS_COLOR_SURFACE_NEUTRAL_100_DARK};
  background-color: hsla(33, 0%, 0%, 0.05);
  height: fit-content;
  box-sizing: border-box;

  svg {
    flex: 1 0 24px;
  }

  a {
    font-weight: bold;
    border-bottom: ${SYS_COLOR_SURFACE_NEUTRAL_100_DARK};
    color: inherit;
  }
`;
export const CloseButtonWrapper = styled.div `
  display: flex;
  justify-content: flex-end;
  width: 100%;
  position: absolute;
  top: 0px;
  right: 0px;
  background-color: var(--colors-background-level-1-611444a);
  z-index: 100;
`;
export const StyledCloseButton = styled((props) => React.createElement(IconButton, Object.assign({}, props))) `
  position: fixed;
  right: 0;
  top: 0;
`;
export const autocompleteCSS = `
    .pac-container {
      background-color: #ffffff;
      padding-block: 24px 24px;
      padding-inline: 16px 16px;
      z-index: 10000;
      position: fixed !important;
    }

    .pac-icon {
      display: none;
    }
   .pac-item,.pac-item-query, .pac-matched {
      color: '#333333';
      font-size: 16px;
      font-family: AudiType,sans-serif;
      font-stretch: 105%;
      line-height: 24px;
      font-weight: 400;
      border-top: none;
    }
    .pac-item{
      padding: 0px;
    }
     .pac-item:not(:last-child) {
      border-block-end: 1px solid #d9d9d9;
      padding-block-end: 10px; 
    }
    .pac-item:not(:first-child) {
      padding-block-start: 10px; 
    }
    .pac-item:hover, .pac-item-selected, .pac-item-selected:hover{
      background-color: '#f2f2f2';
      padding-inline-start: 8px;
      cursor: pointer;
    }
    .pac-item:hover span, .pac-item-selected:hover span, .pac-item-selected span{
      color: '#000000';
    }
    .marker-with-counter{
      margin-top: -6px;
    }
  `;
